module.exports = __webpack_public_path__ + "static/img_0028_dpp_optimized-b971d64f587846437cec1528537daec8.jpg";